import { itIT } from '@mui/material/locale';
import { orange } from '@mui/material/colors';

const fonts = {
  primary: 'Fira Sans Condensed, sans-serif',
  secondary: 'Playfair Display, serif',
};

const MUI_THEME = {
  itIT,
  shadows: Array(25).fill('none'),
  spacing: 20,
  tonalOffset: 0.2,
  contrastThreshold: 10,
  shape: { borderRadius: 4 },

  props: {
    MuiAccordionSummary: {
      disableElevation: true,
    },
  },
  palette: {
    type: 'light',
    primary: {
      main: '#da5f06',
    },
    secondary: {
      main: '#c2d1d9',
    },
    background: {
      default: 'var(--default-bg-color)',
      paper: '#FAF7F6',
    },
    text: {
      primary: '#30231F',
    },
  },
  typography: {
    fontFamily: fonts.primary,
    subtitle1: {
      fontFamily: fonts.primary,
    },
    subtitle2: {
      fontFamily: fonts.primary,
    },
    body1: {
      fontFamily: fonts.primary,
    },
    body2: {
      fontFamily: fonts.primary,
    },
    button: {
      fontFamily: fonts.primary,
    },
    caption: {
      fontFamily: fonts.primary,
    },
    overline: {
      fontFamily: fonts.primary,
    },
    h1: {
      fontFamily: fonts.secondary,
    },
    h2: {
      fontFamily: fonts.secondary,
    },
    h3: {
      fontFamily: fonts.secondary,
    },
    h4: {
      fontFamily: fonts.secondary,
    },
    h5: {
      fontFamily: fonts.secondary,
    },
    h6: {
      fontFamily: fonts.secondary,
    },
  },
  components: {
    MuiTreeItem: {
      styleOverrides: {
        root: {
          //backgroundColor: 'red',
          '.Mui-selected': {
            background: 'transparent !important;',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          padding: '8px 24px',
          borderRadius: '20px',
          textTransform: 'none',
          fontSize: 'inherit',
          variants: [
            {
              props: [{ variant: 'contained' }],
              style: {
                backgroundColor: '#da5f06 !important',
              },
            },
            {
              props: { dense: true },
              style: {
                padding: '4px 24px',
              },
            },
          ],
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { fontSize: 'extra-small' },
              style: {
                fontSize: '1rem',
              },
            },
            {
              props: { fontSize: 'large' },
              style: {
                fontSize: '3rem',
              },
            },
            {
              props: { fontSize: 'extra-large' },
              style: {
                fontSize: '3.5rem',
              },
            },
          ],
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          '&:before': {
            display: 'none',
          },
          backgroundColor: 'transparent',
          '&.Mui-expanded': { backgroundColor: '#FFF3D4' },
        },
      },
    },

    MuiFab: {
      styleOverrides: {
        backgroundColor: orange[700],
        root: {
          '& .MuiTabs-scroller': {
            '& .MuiTabs-indicator': {
              height: 0,
              borderRadius: '20px 20px 0 0',
              backgroundColor: orange[700],
            },
          },
        },
      },
    },

    /*  MuiTabs: {
      indicator: {
        backgroundColor: orange[700],
      },
      styleOverrides: {
        root: {
          '& .MuiTabs-scroller': {
            '& .MuiTabs-indicator': {
              height: 0,
              borderRadius: '20px 20px 0 0',
              backgroundColor: orange[700],
            },
          },
        },
      },
    }, */

    /* MuiButtonBase: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {},
        },
      },
      defaultProps: {
        disableRipple: true,
        size: 'small',
      },
    }, */

    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          input: {
            '&:-webkit-autofill': {
              WebkitBoxShadow: 'none',
            },
          },
        },
      },
    },
  },

  overrides: {
    MuiTreeItem: {
      '.Mui-selected': {
        backgroundColor: 'trasparent !important;',
      },
    },
  },
};

export default MUI_THEME;
